<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		/>

		<section class="main-content faq-section background-dark">
			<frequently-asked-questions-overview
				v-for="faq in faqs"
				:key="faq.ID"
				:items="faq.faqitems"
				:subtitle="faq.subtitle"
				:header="faq.header"
			/>
			<div class="row align-center">
				<div class="columns column12">
					<nuxt-link class="button" :to="localePath('contact')">
						{{ $t('faqDifferentQuestion') }}
					</nuxt-link>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const localePath = useLocalePath();
const config = useRuntimeConfig();

const { page, fetchPage } = usePage();
const { locale } = useI18n();
const { defaults, fetchDefaults } = useDefaults();

await fetchPage();
await fetchDefaults();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/faqs`,
});

function stripHtml(html) {
	//eslint-disable-next-line
	if (typeof html !== 'string') return '';

	return html.replace(/<[^>]*>/g, '').trim();
}

useHead({
	script: [
		{
			type: 'application/ld+json',
			innerHTML: JSON.stringify({
				'@context': 'http://schema.org',
				'@type': 'FAQPage',
				name: `Official ${defaults.value[locale.value].website.hotelName} FAQ`,
				about: {
					'@type': 'Hotel',
					'@id': `${config.public.siteUrl}#hotel`,
				},
				mainEntity: faqs.value.flatMap((section) =>
					section.faqitems.map((item) => ({
						'@type': 'Question',
						name: item.question,
						acceptedAnswer: {
							'@type': 'Answer',
							text: stripHtml(item.answer),
						},
					})),
				),
			}),
		},
	],
});
</script>
